/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconIndentDecrease = createReactComponent("outline", "indent-decrease", "IconIndentDecrease", [["path", { "d": "M20 6l-7 0", "key": "svg-0" }], ["path", { "d": "M20 12l-9 0", "key": "svg-1" }], ["path", { "d": "M20 18l-7 0", "key": "svg-2" }], ["path", { "d": "M8 8l-4 4l4 4", "key": "svg-3" }]]);

export { IconIndentDecrease as default };
//# sourceMappingURL=IconIndentDecrease.mjs.map
